module.exports = __webpack_public_path__ + "img/install-devices-en.301a9e4f.png";